<template>
  <div style="display: inline !important;">
    <el-button title="编辑" @click="show(scope.row)" icon="el-icon-edit" style="margin-right:10px" type="primary" size="mini" plain></el-button>
    <el-popover v-if="btn_more" placement="right" trigger="hover">
      <el-button slot="reference" size="mini" plain icon="el-icon-more-outline"></el-button>
      <el-button v-if="btn_delete" @click="del()" icon="el-icon-delete" type="danger" size="mini">删除</el-button>
      <el-button v-if="btn_sort" @click="showSort(scope)" icon="el-icon-sort" size="mini" plain>排序</el-button>
      <template id="append">
        <slot></slot>
      </template>
    </el-popover>
    <el-dialog title="请输入排序值" :width=dialog.width :visible.sync="dialog.show">
      <el-form>
        <el-row :gutter="20">
          <my-input :span="24" label="正数为下降排序，负数为上升排序" v-model="dialog.num" :required="true" type="number"></my-input>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.show = false">关 闭</el-button>
        <el-button type="primary" @click="sort()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {

  props: {
    scope: {},
    show: {},
    action: {},
    list: {},
    table: {},
    save: {},
    btn_delete: { default: true },
    btn_sort: { default: true },
    btn_more: { default: true },
  },

  data() {
    return {
      dialog: { show: false, width: "300px", num: 1, scope: {} },
    }
  },

  methods: {

    showSort(scope) {
      this.dialog.scope = scope;
      this.dialog.num = 1;
      this.dialog.show = true;
    },

    sort() {
      let scope = this.dialog.scope;
      let num = this.dialog.num;
      let index = scope.$index;
      let now = this.table[index];
      let trans = this.table[Number(index) + Number(num)];
      if (!trans) { this.$message.error("输入数值超出范围值！"); return; }
      let temp = trans['sortid'];
      trans['sortid'] = now['sortid'];
      now['sortid'] = temp;
      this.$axios.post(this.action, now).then((res) => {
        if (res.data.code === 200) {
          this.$axios.post(this.action, trans).then((res) => {
            if (res.data.code === 200) {
              this.list();
              this.dialog.show = false;
            }
            else this.$message.error(res.data.msg);
          });
        } else this.$message.error(res.data.msg)
      });
    },

    del() {
      this.$confirm("此操作将删除当前项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let obj = this.scope.row;
        obj["deltime"] = new Date();
        this.$axios.post(this.action, obj).then((res) => {
          if (res.data.code === 200) this.list();
          else {
            obj["deltime"] = null;
            this.$message.error(res.data.msg);
          }
        });
      })
    }
  }
}
</script>

<style>
</style>